"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROARR = exports.Roarr = exports.logLevels = exports.getLogLevelName = void 0;
const globalthis_1 = __importDefault(require("globalthis"));
const constants_1 = require("./constants");
Object.defineProperty(exports, "logLevels", { enumerable: true, get: function () { return constants_1.logLevels; } });
const createLogger_1 = require("./factories/createLogger");
const createRoarrInitialGlobalStateBrowser_1 = require("./factories/createRoarrInitialGlobalStateBrowser");
const getLogLevelName_1 = require("./getLogLevelName");
Object.defineProperty(exports, "getLogLevelName", { enumerable: true, get: function () { return getLogLevelName_1.getLogLevelName; } });
const globalThis = (0, globalthis_1.default)();
const ROARR = globalThis.ROARR = (0, createRoarrInitialGlobalStateBrowser_1.createRoarrInitialGlobalStateBrowser)(globalThis.ROARR || {});
exports.ROARR = ROARR;
const serializeMessage = (message) => {
    return JSON.stringify(message);
};
const Roarr = (0, createLogger_1.createLogger)((message) => {
    var _a;
    if (ROARR.write) {
        // Stringify message as soon as it is received to prevent
        // properties of the context from being modified by reference.
        ROARR.write(((_a = ROARR.serializeMessage) !== null && _a !== void 0 ? _a : serializeMessage)(message));
    }
});
exports.Roarr = Roarr;
